<template>
  <section class="card">
    <div class="card__nps">
      <div class="card__nps__heart-icon">
        <svg viewBox="0 0 512 512" width="21" title="heart">
          <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
        </svg>
      </div>
      <h2 class="card__nps__title">Uma pesquisa para ouvir sua opinião</h2>
      <p class="card__nps__description">Você gostou da experiência de contratação? Contamos com seu feedback para melhorarmos ainda mais suas experiências. São menos de 2 minutinhos, vamos lá?</p>

      <div class="card__nps__action">
        <Button label="Avaliar agora" theme="purple-filled" @click.prevent="setRating('')" />
      </div>

      <ul :class="['card__nps__rating', { 'card__nps__rating--creditPage': creditPageSuccess }]">
        <li v-for="evaluationGrade in evaluationGrades" :key="evaluationGrade" :class="['card__nps__rating__evaluation', { 'card__nps__rating__evaluation--evaluated': rating === evaluationGrade }]">
          <a class="card__nps__rating__evaluation__link" @click.prevent="setRating(evaluationGrade)">{{ evaluationGrade }}</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import Button from '@/components/ui/Button.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'NPS',
    props: {
      creditPageSuccess: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Button
    },
    data () {
      return {
        evaluationGrades: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
        rating: 0
      }
    },
    computed: {
      ...mapState(['device'])
    },
    methods: {
      setRating (value) {
        this.rating = `nps=${value || ''}&`
        const { name, email } = this.device.personalData
        const params = `${this.rating}nome=${name}&email=${email}&produto=Seguro-Equipamentos-Portateis`

        window.open(`https://my.inovyosurvey.com/s3/6edb62651f96?${params}`, '_blank')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 8px;
    background-color: white;
    padding: 40px 40px 60px 40px;
    text-align: center;
    width: 100%;
    min-height: 311.11px;
    margin-bottom: 16px;
    margin-top: 16px;

    @media screen and (max-width: 768px) {
      padding: 22px;
    }

    &__nps {

      &__heart-icon {
        align-items: center;
        display: flex;
        justify-content: center;
        background-color: #FFb3D7;
        max-width: 60px;
        height: 55px;
        border-radius: 100%;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
        margin: 0 auto;

        svg {
          fill: #B21A63;
        }
      }

      &__title {
        font-size: 24px;
        font-weight: 700;
        color: #3F4956;
        line-height: 125%;
        margin-top: 23px;

        @media screen and (min-width: 768px) {
          margin-top: 7px;
        }
      }

      &__description {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #959494;
        max-width: 646px;
        width: 100%;
        margin: 16px auto;
      }

      &__rating {
        align-items: center;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-around;
        margin-top: 32px;
        width: 100%;

        @media screen and (max-width: 767px) {
          display: none;
        }

        &--creditPage {
          li {
            height: 40px;
            width: 40px;
          }
        }

        &__evaluation {
          align-items: center;
          background-color: #929aa6;
          border-radius: 100%;
          cursor: pointer;
          display: flex;
          height: 55px;
          justify-content: center;
          position: relative;
          text-align: center;
          transition: 0.6s all ease-out;
          width: 59px;

          &:hover,
          &:hover ~ li {
            background-color: #4F1ABA;
          }

          &--evaluated,
          &--evaluated ~ li {
            background-color: #4F1ABA;
          }

          &__link {
            color: white !important;
            font-family: 'Overpass', sans-serif;
            font-size: 20px;
            font-weight: 700;
            text-decoration: none;
            width: 59px;

            &:hover {
              text-decoration: none;
            }
          }
        }
      }

      &__action {
        display: flex;
        justify-content: center;
        margin: 0 auto;

        @media screen and (min-width: 768px) {
          display: none;
        }
      }
    }
  }
</style>
